import React, { Component } from 'react';
import Sheet from './StudentstundenUebersichtSheet';
import moment from 'moment';

moment.locale('de');

export default class StudentstundenUebersichtSheetContainer extends Component {
    state = {
        selectedMonth: null,
    };

    componentDidMount() {
        this.onPropsChange(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.onPropsChange(nextProps);
    }

    onPropsChange = props => {
        console.log(props, 'onPropsChange');
        if (props.sheets.length > 0) {
            this.setState({
                selectedMonth: { month: props.sheets[0].month, year: props.sheets[0].year },
            });
        }
    };

    onMonthChange = month => {
        this.setState({
            selectedMonth: { month: month.month, year: month.year },
        });
    };

    getActiveSheet = () => {
        return this.props.sheets.filter(sheet => sheet.month === this.state.selectedMonth.month && sheet.year === this.state.selectedMonth.year)[0];
    };

    render() {
        console.log(this.state.selectedMonth, 'this.state.selectedMonth');
        console.log(this.props.sheets, 'this.props.sheets');
        if (this.props.sheets.length === 0 || this.state.selectedMonth === null) {
            return null;
        }

        const months = this.props.sheets.map(sheet => ({
            name: moment(`${sheet.year}-${sheet.month}-01`, 'YYYY-M-DD').format('MMMM'),
            month: sheet.month,
            year: sheet.year,
        }));
        const activeSheet = this.getActiveSheet();
        const state = this.state;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col" style={{ 'border-bottom': '1px solid #dee2e6' }} />
                    <div className="col-auto pl-0">
                        <ul className="nav nav-tabs nav-tabs-uebersicht">
                            {months.map(month => (
                                <li className="nav-item" key={`${month.month}-${month.year}`}>
                                    <a
                                        className={`nav-link ${
                                            state.selectedMonth.month === month.month && state.selectedMonth.year === month.year ? 'active' : ''
                                        }`}
                                        href="#"
                                        onClick={() => this.onMonthChange(month)}>
                                        {`${month.name} ${month.year}`}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <Sheet sheet={activeSheet} />
            </React.Fragment>
        );
    }
}
